export default "__VITE_ASSET__Dh8TW4SN__"